import Home from './Home';

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home/index.ts